import { Tooltip } from '@mui/material'
import { Error, Info } from '@mui/icons-material'
import React from 'react'
import Colors from 'utils/Colors'

import { BGC_FIELDS } from 'utils/constants/bgcFields'
import { buildScore } from 'utils/functions'
import AccessTimeIcon from '@mui/icons-material/AccessTime'

import { reportErrorMessage } from 'utils/errorReporter'
import styles from '../styles'

const BuildBGCScoreBoard = (props) => {
  const classes = styles()
  const { scoreBoardData } = props

  const showWaitingClockIcon = () => (
    <AccessTimeIcon style={{ color: Colors.gray, fontSize: '2rem' }} />
  )

  const scoreTitle = (type) => {
    switch (type) {
      case BGC_FIELDS.compliance_list:
        return 'Compliance List'
      case BGC_FIELDS.frontier_zone:
        return 'Região de risco'
      case BGC_FIELDS.negative_media:
        return 'Mídia Negativa'
      case BGC_FIELDS.pep:
        return 'PEP'
      case BGC_FIELDS.restriction_data:
        return 'Listas Restritivas'
      case BGC_FIELDS.process_data:
        return 'Processos Judiciais'
      case BGC_FIELDS.family_relation_data:
        return null
      case BGC_FIELDS.company_data:
        return 'Participações Societárias e ESG'
      case BGC_FIELDS.financial_pendings_data:
        return 'Pendências Financeiras'
      default:
        return null
    }
  }
  const showPointsCell = (field) => (
    <React.Fragment>
      {scoreBoardData.score_data[field].value}

      {scoreBoardData.score_data[field].value < 1 &&
        scoreBoardData.score_data[field].value !== 0
        ? ' ponto'
        : ' pontos'}
    </React.Fragment>
  )

  const showReasonCell = (field) =>
    scoreBoardData.score_data[field].reason ? (
      scoreBoardData.score_data[field].reason
    ) : (
      <Error style={{ color: Colors.yellow }} />
    )


    const renderError = () => {
      const errorMsg = 'Ocorreu um erro ao tratar os dados de pontuação do Background Check'
      reportErrorMessage(errorMsg, 'BuildBGCScoreBoard')
      
      return (
        <tbody>
          <tr className={classes.errorCaptured}>
            <td colSpan="20" style={{ padding: 10 }}>
              {errorMsg}
            </td>
          </tr>
        </tbody>
      )
    }
  return (
    <div className={classes.container}>
      <table className={classes.dataTable}>
        <thead>
          <tr>
            <th>Parâmetro</th>
            <th>
              <span>
                <span>Pontuação</span>
                <span>
                  <Tooltip title="Quanto maior o score, maior o risco">
                    <Info fontSize="small" style={{ color: '#AAA' }} />
                  </Tooltip>
                </span>
              </span>
            </th>
            <th>Motivo</th>
          </tr>
        </thead>
        {scoreBoardData && (
          <tbody>
            {Object.keys(BGC_FIELDS).map((field) => {
              const title = scoreTitle(field)
              return (
                title && (
                  <tr key={`tr:${field}`}>
                    <td>{title}</td>
                    <td>
                      {scoreBoardData.score_data[field]
                        ? showPointsCell(field)
                        : showWaitingClockIcon()}
                    </td>
                    <td>
                      {scoreBoardData.score_data[field]
                        ? showReasonCell(field)
                        : showWaitingClockIcon()}
                    </td>
                  </tr>
                )
              )
            })}
            <tr style={{ fontWeight: 'bold' }}>
              <td>Score Final</td>
              <td>
                {scoreBoardData.is_complete ? (
                  <span style={buildScore(scoreBoardData.final_score)}>
                    {`
                  ${scoreBoardData.final_score} 
                  ${scoreBoardData.final_score < 1 &&
                        scoreBoardData.final_score !== 0
                        ? ' ponto'
                        : ' pontos'
                      }
                `}
                  </span>
                ) : (
                  showWaitingClockIcon()
                )}
              </td>
              <td
                style={{
                  color:
                    scoreBoardData.risk ===
                      'Dados inconsistentes - score de risco comprometido'
                      ? Colors.yellow
                      : 'inherit',
                }}
              >
                {scoreBoardData.is_complete
                  ? scoreBoardData.risk
                    ? scoreBoardData.risk
                    : 'N/A'
                  : showWaitingClockIcon()}
              </td>
            </tr>
          </tbody>
        )}
        {!scoreBoardData && renderError()}
      </table>
    </div>
  )
}

export default BuildBGCScoreBoard
